import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import auth from "../firebase.init";
import { Helmet } from "react-helmet";

const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [resetSent, setResetSent] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        
        if (!email.trim()) {
            setError("Please enter your email address");
            return;
        }
        
        setLoading(true);
        try {
            await sendPasswordResetEmail(auth, email);
            setResetSent(true);
            setError("");
        } catch (error) {
            setError(getErrorMessage(error));
        } finally {
            setLoading(false);
        }
    };

    // Function to map Firebase error codes to custom messages
    const getErrorMessage = (error) => {
        if (!error) return "";
        switch (error.code) {
            case "auth/user-not-found":
                return "No user found with this email address.";
            case "auth/invalid-email":
                return "Please enter a valid email address.";
            default:
                return "An unexpected error occurred. Please try again later.";
        }
    };

    return (
        <>
            <Helmet>
                <title>Reset Password - Recover Your Account</title>
                <meta name="description" content="Forgot your password? Reset it here and regain access to your account. Follow the instructions to securely reset your password." />
            </Helmet>

            <section className="reset-password-page full-height" style={{ height: 911 }}>
                <div
                    className="login-page__shape-1"
                    style={{ backgroundImage: "url(images/shapes/login-page-shape-1.png)" }}
                />
                <div className="login-page__shape-2" />
                <div className="container">
                    <div className="reset-password-page__inner">
                        <div className="reset-password-page__close-icon">
                            <Link to="/">
                                <span className="icon-close" />
                            </Link>
                        </div>
                        <div className="reset-password-page__top">
                            <div className="reset-password-page__logo">
                                <Link to="/">
                                    <img src="images/resource/login-page-logo.png" alt="Logo" />
                                </Link>
                            </div>
                        </div>
                        <div className="reset-password-option">
                            <Link to="/login">
                                <span className="icon-prev" />
                                Reset Password
                            </Link>
                        </div>
                        
                        {resetSent ? (
                            <div className="success-message text-center my-4">
                                <div className="success-icon mb-3">
                                    <i className="fa fa-check-circle fa-3x text-success"></i>
                                </div>
                                <h4>Password Reset Email Sent!</h4>
                                <p>We've sent instructions to reset your password to {email}.</p>
                                <p className="mt-3">
                                    <small>
                                        Didn't receive the email? Check your spam folder or{" "}
                                        <button 
                                            onClick={() => {
                                                setResetSent(false);
                                                handleResetPassword();
                                            }}
                                            className="btn btn-link p-0 text-decoration-none"
                                        >
                                            try again
                                        </button>
                                    </small>
                                </p>
                                <Link to="/login" className="thm-btn mt-3">
                                    Return to Login
                                </Link>
                            </div>
                        ) : (
                            <form onSubmit={handleResetPassword} className="register-one__form">
                                <div className="row">
                                    {error && (
                                        <div className="col-md-12">
                                            <div className="alert alert-danger" role="alert">
                                                {error}
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-md-12">
                                        <div className="register-one__form__email">
                                            <input 
                                                type="email" 
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder="Enter Your Email" 
                                                required
                                            />
                                            <i className="icon-envelope" />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <button 
                                            type="submit" 
                                            className="thm-btn register-one__btn"
                                            disabled={loading}
                                        >
                                            {loading ? "Sending..." : "Reset Password"}
                                        </button>
                                    </div>
                                    <div className="col-md-12 mt-4 text-center">
                                        <p>
                                            <Link to="/login">Back to Login</Link>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ResetPassword;